/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-06-27 15:08:48
 **/

import { fromEvent } from "rxjs";
import useAutoEvent from "./useAutoEvent";
import { DependencyList } from "react";

export default function useBeforeUnload(handler: (event: Event) => void, deps: DependencyList = []) {
	useAutoEvent(
		[
			{
				event: fromEvent(window, "beforeunload"),
				handler
			}
		],
		[...deps]
	);
}
